import { FARM_STATE } from "./farm-state";

export const getFarmState = (
  chainId: number | undefined,
  poolAddress: string,
) => {
  if (!chainId) return;
  return FARM_STATE[chainId]?.[poolAddress];
};
